import { SupplierHeatsPage } from "./SupplierHeatsPage";

const SupplierHeats = () => {
	return <SupplierHeatsPage />;
};
export default SupplierHeats;
